exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left-nav[data-v-f27a738e]{width:100%!important;justify-content:flex-end!important}.nav-wrapper[data-v-f27a738e]{position:fixed;width:100vw;background-color:transparent!important}.header-container[data-v-f27a738e]{max-width:100%!important;border:.08rem solid #000;border-radius:3rem;margin:2rem;padding:.7rem 3rem;background-color:rgba(255,255,255,.2);backdrop-filter:blur(15px);-webkit-backdrop-filter:blur(7px)}.fixed-top[data-v-f27a738e]{position:fixed;width:100%;top:0;z-index:1030}.navbar[data-v-f27a738e]{display:flex;justify-content:space-between;position:fixed;width:100%;z-index:100}.dropdown-toggle[data-v-f27a738e],.nav-item>a[data-v-f27a738e],.nav-link.dropdown-toggle[data-v-f27a738e]{margin-bottom:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f27a738e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/nav.vue
// module id = 290
// module chunks = 0